import { useState, useEffect } from 'react'
import { DEBUG_MODE } from '../../utilities/config'

function getWindowDimensions() {
  try {
    const { innerWidth: width, innerHeight: height } = window
    return {
      width,
      height,
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export default function useWindowDimensions() {
  try {
    const [windowDimensions, setWindowDimensions] = useState<any>(
      getWindowDimensions()
    )
    useEffect(() => {
      function handleReorientation() {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('orientationchange', handleReorientation)
      return () => window.removeEventListener('orientationchange', handleReorientation)
    }, [])
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    return windowDimensions
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}
